<template>
  <LayoutDefault class="pages-discounts">
    <div class="pages-discounts__container">
      <div class="products-choice-block" v-if="showMenu">
        <div
        class="product-choice"
        :class="{'active': type_choice === 'choices'}"
        v-on:click="changeChoice('choices')"
        v-if="products.length"
        >
        {{ state.app.locale.productsType.selected }}
        </div>
        <div
        class="product-choice"
        :class="{'active': type_choice === 'all'}"
        v-on:click="changeChoice('all')"
        >
        {{ state.app.locale.productsType.all }}
        </div>
        <div
        class="product-choice"
        :class="{'active': type_choice === 'health'}"
        v-on:click="changeChoice('health')"
        >
        {{ state.app.locale.productsType.health }}
        </div>
        <div
        class="product-choice"
        :class="{'active': type_choice === 'beauty'}"
        v-on:click="changeChoice('beauty')"
        >
        {{ state.app.locale.productsType.beauty }}
        </div>
        <div
        class="product-choice"
        :class="{'active': type_choice === 'personal_care'}"
        v-on:click="changeChoice('personal_care')"
        >
        {{ state.app.locale.productsType.personal_care }}
        </div>
      </div>
      <SectionsDiscounts
        ref="section"
        :total-price="totalPrice"
        :products-count="productsCount"
        :total-personal-points="totalPersonalPoints"
        :total-group-points="totalGroupPoints"
        :profit-value="this.trees['VIP'].total"
        :income-value="this.trees['ABO'].total"
        :categories-abo="categoriesAbo"
        :categories-vip="categoriesVip"
        :children="children"
        :typeChoice="type_choice"
        @selectProduct="onProductsSelect"
        @selectChildren="(items) => setChildren(items, 'firstLevel')"
        @selectChildrenChildren="(items) => setChildren(items, 'secondLevel')"
        @all="setAll"
      />

      <BundlesSectionNavigation
        class="pages-products__navigation"
        :next-title="state.app.locale.redirectPage.navigation.next"
        :prev-title="state.app.locale.redirectPage.navigation.prev"
        @next="nextSection"
        @prev="prevSection"
      />
    </div>
  </LayoutDefault>
</template>

<script>
import LayoutDefault from "@/layout/LayoutDefault.vue";
import SectionsDiscounts from "@/components/sections/SectionsDiscounts.vue";
import BundlesSectionNavigation from "@/components/bundles/SectionNavigation.vue";
import { useState } from "@/App.store";

export default {
  name: "DiscountsPage",
  components: { BundlesSectionNavigation, LayoutDefault, SectionsDiscounts },
  setup() {
    const state = useState();

    return {
      state,
    };
  },
  data() {
    return {
      products: [],
      trees: {},
      children: {
        firstLevel: 0,
        secondLevel: 0,
      },
      type_choice: "all",
      productsSelected: [],
      showMenu: true,
    };
  },
  watch: {
    children: {
      handler() {
        this.setTrees();
      },
      deep: true,
      immediate: true,
    },
    products: {
      handler() {
        this.setTrees();
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    productsCount() {
      return this.products.length;
    },
    totalPrice() {
      return this.products.reduce((sum, item) => sum + item.price, 0);
    },
    totalPersonalPoints() {
      return this.products
        .reduce((sum, item) => sum + item.score, 0)
        .toFixed(2);
    },
    totalGroupPoints() {
      return (
        (1 +
          this.children.firstLevel +
          this.children.firstLevel * this.children.secondLevel) *
        this.totalPersonalPoints
      ).toFixed(2);
    },

    categoriesAbo() {
      const categories = [
        {
          name: this.state.app.locale.redirectPage[
            this.trees["ABO"].details.personalActivity.text
          ],
          tooltip:
            this.state.app.locale.redirectPage.amway[
              this.trees["ABO"].details.personalActivity.tooltip
            ],
          value: this.trees["ABO"].details.personalActivity.value,
        },
        {
          name: this.state.app.locale.redirectPage[
            this.trees["ABO"].details.groupActivity.text
          ],
          tooltip:
            this.state.app.locale.redirectPage.amway[
              this.trees["ABO"].details.groupActivity.tooltip
            ],
          value: this.trees["ABO"].details.groupActivity.value,
        },
        {
          name: this.state.app.locale.redirectPage[
            this.trees["ABO"].details.stableBusiness.text
          ],
          tooltip:
            this.state.app.locale.redirectPage[
              this.trees["ABO"].details.stableBusiness.tooltip
            ],
          value: this.trees["ABO"].details.stableBusiness.value,
        },
      ];

      if (this.trees["ABO"].details.leadership.value) {
        categories.push({
          name: this.state.app.locale.redirectPage[
            this.trees["ABO"].details.leadership.text
          ],
          tooltip:
            this.state.app.locale.redirectPage[
              this.trees["ABO"].details.leadership.tooltip
            ],
          value: this.trees["ABO"].details.leadership.value,
        });
      }

      return categories;
    },
    categoriesVip() {
      return [
        {
          name: this.state.app.locale.redirectPage[
            this.trees["VIP"].details.personalActivity.text
          ],
          tooltip:
            this.state.app.locale.redirectPage.loyalty[
              this.trees["VIP"].details.personalActivity.tooltip
            ],
          value: this.trees["VIP"].details.personalActivity.value,
        },
        {
          name: this.state.app.locale.redirectPage[
            this.trees["VIP"].details.groupActivity.text
          ],
          tooltip:
            this.state.app.locale.redirectPage.loyalty[
              this.trees["VIP"].details.groupActivity.tooltip
            ],
          value: this.trees["VIP"].details.groupActivity.value,
        },
      ];
    },
  },
  methods: {
    prevSection() {
      this.$router.push({ path: "/" });
    },
    nextSection() {
      this.finishTree();
    },

    onProductsSelect(products) {
      this.products = [...products];
    },
    setChildren(items, level) {
      this.children[level] = items.length;

      if (level === "firstLevel" && !items.length) {
        this.$refs.section.$refs.childrenSecondLevel.resetSelected();
        this.children.secondLevel = 0;
      }
    },

    setTree(clientType) {
      const { tree } = this.state.generateTree({
        children: {
          firstLevel: this.children.firstLevel,
          secondLevel: this.children.secondLevel,
        },
        points: Math.floor(this.totalPersonalPoints),
        clientType,
        generateType: "discount",
      });

      this.trees[clientType] = this.state.getTreeParams(tree);
    },
    setTrees() {
      this.setTree("ABO");
      this.setTree("VIP");
    },

    finishTree() {
      this.$router.push({ path: "/income" });
    },
    changeChoice(choice) {
      this.type_choice = choice;
    },
    setAll() {
      this.type_choice = "all";
    },
  },
};
</script>

<style scoped lang="scss">
.pages-discounts {
  &__container {
    margin: 0 auto;
    width: 100%;
    padding: 85px 36px 24px;
    overflow: hidden;

    @media screen and (max-width: 480px) {
      max-width: 375px;
      padding: 74px 16px 24px;
    }
  }

  .products-choice-block {
    display: flex;
    justify-content: center;
    width: auto;
    margin-bottom: 30px;

    @media screen and (max-width: 767px) {
      overflow-x: auto;
      justify-content: flex-start;
      margin-bottom: 20px;
    }

    .product-choice {
      color: #5E5E5E;
      font-family: GT Walsheim Pro, sans-serif;
      border: 1px solid #E4E4E4;
      border-radius: 100px;
      padding: 8px 10px;
      margin: 0 5px;
      cursor: pointer;
      width: fit-content;
      flex-shrink: 0;
    }

    .active {
      border: 2px solid #5E5E5E;
      color: #5E5E5E;
      font-weight: 700;
    }
  }
  .products-choice-block::-webkit-scrollbar {
    width: 0;
  }
}
</style>
